import { gql } from '@apollo/client'

export const GET_ALL_Video = gql`
query videolayers($courseName:String!,$version:Float!,$status:Boolean!,$contentType:String!,$isRoot:Boolean!){
  layers(
  courseName:$courseName
  version: $version
  status: $status
  contentType: $contentType
  isRoot:$isRoot
  ){
    _id
    title
    icon
    contentType
    status
    description
    position
    layerType
    subLayerCount
    subLayers{
      position
      title
      contentType
      icon
      totalContent
    progressStatus{
      score
    }
      description
      _id
      author{
        name
      }
    }
    }
  }`

export const GET_Free_Video = gql`
query freevideo($courseName: [String!]!, $page: Int!, $limit: Int!, $version: Float!) {
  freevideo(courseName: $courseName, page : $page, limit : $limit,version: $version) {
          pageCount
          itemCount
          videos {
              _id
              title
              topic
              subject
              thumbnail
              subjectDetail {
                subjectName
                subjectId
                topicId
                topicName
                }
         subjectDetails {
              _id
              subjectName
               topic {
            topicName
                }
             }
              versions
              authorId
              videoUrlId
              author {
                  name
                  _id
                  avatar
              }
              rating
              purchaseStatus
              duration
              progress {
              _id
              isBookMarked
              isCompleted
              duration{
                  duration
                  language
              }
              }
           videoUrls {
                  language
                  videoUrlId
                  duration
          fragments {
               topicTitle
                from
                to
    }
  }
          }
  }
}`

export const GET_Video_Layer = gql`
  query videolayer($_id:String!,$language:String!,$contentType:String!) {
    layer(_id: $_id) {
        _id
        title
        parents
        description
        icon
        subject
        totalContent
        subjectDetail {
          subjectName
          subjectId
          topicId
          topicName
          }
        author {
            name
        }
        progressStatus{
              score
        }
        subLayers {
            position
            _id
            layerType
            icon
            title
            progressStatus {
                score
            }
            author {
                name
            }
            totalContent
            subContents(language: $language, contentType: $contentType) {
                contentId
                pearl {
                    _id
                    pearlsCode
                    title
                    description
                    status
                }
            }
            subLayers {
                position
                _id
                layerType
                title
                icon
            totalContent
                author{
                    name
                }
                progressStatus{
                    score
                }
                subContents(language: $language, contentType: $contentType) {
                    contentId
                }
            }
        }
        subContents(language: $language, contentType: $contentType){
          questionBank {
            _id
            title
            icon
            purchaseStatus
            rating
            questionIds
            subjectDetail {
            subjectName
            subjectId
            topicId
            topicName
            }
            progress{
                 questions {
                questionId
              }
              isCompleted
              startTime
              questionInterval
            }
            }
        video {
            _id
            title
            author{
            name
            }
            isNewVideo
            notes
            purchaseStatus
            subjectDetail {
              subjectName
              subjectId
              topicId
              topicName
              }
            thumbnail
            rating
            duration
            videoUrlId
            progress {
                isBookMarked
                isCompleted
                duration {
                  duration
                  language
                }
            }
            videoUrls {
              language
              videoUrlId
              duration
              fragments {
                topicTitle
                from
                to
              }
            }
        }
        }
    }
}`

export const GET_Free_QB = gql`
  query freeqb($courseName: [String!]!, $page: Int!, $limit: Int!) {
    freeqb(courseName: $courseName, page: $page, limit: $limit) {
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
      qbBanks {
        _id
        title
        rating
        icon
        position
        purchaseStatus
        questionIds
        progress{
          questions{
            questionId
            userAnswer
          }
        }
      }
    }
  }`

export const GET_Continue_QB = gql`
  query continueLearningQb($courseName: String!,$subjectId: String, $topicId: String){
    continueLearningQb(courseName: $courseName, subjectId: $subjectId, topicId: $topicId){
      questionbank {
        _id
        title
        rating
        questionIds
        position
        purchaseStatus
        progress{
          questions{
            questionId
            userAnswer
          }
        }
      }
    }
  }`

export const GET_Content_QB = gql`
  query qbList($_id: String!, $language: String!, $contentType: String!) {
    layer(_id: $_id) {
      _id
      parents
      title
      position
      description
      icon
      subjectDetail {
        subjectName
      }
      progressStatus {
          score
      }
      totalContent
      subContents(language: $language, contentType: $contentType) {
          contentId
          position
          questionBank{
              title
              icon
              purchaseStatus
              rating
              questionIds
              subjectDetail {
              subjectName
              }
              progress{
                   questions {
                  questionId
                }
                isCompleted
              }
          }
      }
  }
  }`

export const GET_Instrucation_QB = gql`
  query qbInformation($_id:String!){
    qb(_id:$_id){
      _id
      qbCode
      title
      description
      instruction
      status
      course
      deleteStatus
      subject
      parentLayerId
      parentLayer {
        title
        _id
      }
      subjectDetail {
        subjectId
        topicId
      }
      authorDetails {
        name
      }
      icon
      purchaseStatus
      rating
      progress{
          _id
        isCompleted
        questionInterval
        bookmarkedQids
        isBookMarked
        questions {
          questionId
          userAnswer
      }
      }
      questions{
        _id
        questionCode
        topic
        tags
        reference
        status
        answer
        totalAttemptCount
        answer
        subjectDetail {
          subjectName
          subjectId
        }
          elements {
              type
              data
          }
        pearls{
        pearlsCode
        description
        }
        question{
          questionText
          questionImage
              }
          solution {
          solutionImage
          solutionText
      }
        options{
          _id
          optionText
          optionAttempt
          optionImage
              }
          }
      }
  }`

export const GET_Live_Test = gql`
  query LiveTestList($course: String!) {
    liveTestList(course: $course) {
      _id
      icon
      title
      year
      month
      schedule
      endTest
      category
      serverTime
      duration
      purchaseStatus
      questionCount
      progress {
          attemptedQuesCount
          isCompleted
      }
    }
  }`

export const Get_bookmark_list = gql`
  query profileBookMarksList($contentType: ContentType!, $courseName: String!, $page:Int!, $perPage: Int!) {
    bookmarks(contentType: $contentType, courseName: $courseName, page: $page, perPage: $perPage) {
    pageCount
    itemCount
    hasNextPage
    hasPreviousPage
    bookmarks {
      contentId
        subjectId
        topicId
        video {
            _id
            title
            authorId
            rating
            duration
            thumbnail
            videoUrlId
            subjectDetail {
                subjectName
            }
            author {
                name
            }
            progress {
                duration {
                    duration
                }
            }
        }
        questionbank {
            _id
            title
            position
            description
            rating
            icon
            progress {
                _id
            }
            questions {
                _id
                answer
            }
            subjectDetail {
                subjectName
            }
        }
        
        test {
            _id
            icon
            title
            year
            month
            schedule
            endTest
            serverTime
            duration
            purchaseStatus
            questionCount
            progress {
                _id
                attemptedQuesCount
                questions {
                    questionId
                }
            }
        }
        
        pearl {
            _id
            pearlsCode
            title
            status
            subjectDetail {
                topicName
                subjectName
            }
        }
    }
    }
}`

export const GET_test_By_year_month = gql`
query($course:String!,$testCategory:TestCategory,$years:[Int!]!) {
  testByYearMonth(course: $course, testCategory: $testCategory, years: $years ) {
    year
    month
    total
  }
}`

export const GET_test_by_year = gql`
query($course:String!) {
  testByYear(course: $course) {
    year
    total
  }
}`

export const GET_test_list = gql`
query($course: String!, $startDate: String!, $endDate: String!,$page: Int!, $limit: Int!,$testCategory:TestCategory) {
  testList(course: $course, startDate: $startDate, endDate: $endDate,testCategory: $testCategory, page: $page, limit: $limit) {
    test {
      _id
      icon
      title
      year
      subjectDetail {
        subjectId
      }
      month
      schedule
      endTest
      serverTime
      duration
      category
      purchaseStatus
      questionCount
      progress {
        attemptedQuesCount
        isCompleted
        endTime
      }
    }
    pageCount
  }
}`

export const Get_test_result_count = gql`
query ($resultStatus: Boolean!, $testCategory: TestCategory, $course:  String!, $year:[String!]){
  resultCounts(resultStatus: $resultStatus,testCategory: $testCategory,course:$course,year:$year) {
    monthYear
    year
    month
    count
  }
}`

export const Get_server_time = gql`
query {
  serverTime  
  }
`
export const Get_test = gql`
query testdetails($_id: String!) {
  test(_id: $_id) {
    _id
    title
    totalMarks
    category
    subject
    topic
    endTest
    schedule
    description
    instructions
    status
    deleteStatus
    icon
    isShowingSolution
    result
    purchaseStatus
    rating
    duration
    solutionTime
    serverTime
    testCode
    noOfSections
    resultDecleared
    subjectDetail {
      subjectId
      topicId
    }
    
    questions {
        _id
        questionCode
        subject
        topic
        tags
        reference
        status
        answer
        totalAttemptCount
        answer
        pearls{
          _id
          pearlsCode
          title
          description
          status
          subject
          topic
          }
        elements {
            type
            data
        }
        question {
            questionText
            questionImage
        }
        solution {
            solutionImage
            solutionText
        }
        subjectDetail {
            subjectId
            subjectName
            topicId
            topicName
        }
        
        options {
            _id
            optionText
            optionAttempt
            optionImage
        }
    }
    resultData {
        avgMarks
        avgAccuracy
        avgDuration
        topperMarks
        topperAccuracy
        totalRankers
        manipulatedTotalRankers
    }
    progress {
        _id
        isBookMarked
        bookmarkedQids
        isCompleted
        startTime
        rating
        accuracy
        totalMarks
        duration
        correctQuestions
        incorrectQuestions
        attemptedQuesCount
        marks
        totalMarks
        rank
        manipulatedRank
        endTime
        predictedRank
        guessedCount
        reviewedCount
        questions {
            questionId
            correctAnswer
            userAnswer
            isCorrect
            marks
            isReview
            isGuessed
        }
        unattemptedQids
        subjectStats {
            subjectId
            attemptedQids
            unattemptedQids
            correctQids
            incorrectQids
            subject {
                subjectName
                icon
                qbTopics {
                    _id
                    title
                }
            }
            topics {
                topicId
                attemptedQids
                unattemptedQids
                correctQids
                incorrectQids
            }
            
        }
    }
  }
}`

export const Get_test_details = gql`
query testdetails($_id: String!) {
  test(_id: $_id) {
    _id
    title
    category
    subject
    topic
    endTest
    schedule
    description
    instructions
    status
    deleteStatus
    icon    
    duration
    solutionTime
    serverTime
    testCode
    noOfSections
    resultDecleared
    subjectDetail {
      subjectId
      topicId
    }
    
    questions {
        _id
        questionCode
        subject
        topic
        tags
        reference
        status
        answer
        totalAttemptCount
        answer       
        question {
            questionText
            questionImage
        }        
        subjectDetail {
            subjectId
            subjectName
            topicId
            topicName
        }
        
        options {
            _id
            optionText
            optionAttempt
            optionImage
        }
    }    
    progress {
        _id       
        startTime       
        questions {
            questionId
            correctAnswer
            userAnswer
            isCorrect
            marks
            isReview
            isGuessed
        }
        unattemptedQids       
    }
  }
}`

export const qb_performance = gql`
query performanceSummeryQB($_id: String!){
  qb(_id: $_id) {
    _id
    title
    rating
    subjectDetail {
      subjectId
      topicId
    }
    questions{
      _id
      questionCode
      subject
      topic
      reference
      status
      answer
      totalAttemptCount
      answer
      question{
        questionText
        questionImage
            }
        solution {
        solutionImage
        solutionText
    }
      subjectDetail {
        subjectId
        subjectName
        topicId
        topicName
        
      }
      options{
        _id
        optionText
        optionAttempt
        optionImage
            }
        }
    progress {
      _id
      rating
      duration
      qbId
      marks
      endTime
      accuracy
      totalMarks
      bookmarkedQids
      marks
      correctQuestions
      incorrectQuestions
      attemptedQuesCount
      questions {
        questionId
        correctAnswer
        userAnswer
        isCorrect
        marks
      }
      unattemptedQids
    }
  }
}`

export const GET_All_Bookmarked_List = gql`
query bookmarks($contentType:ContentType!,$courseName:String!,$perPage:Int!,$page:Int!){
  bookmarks(contentType:$contentType,courseName:$courseName,perPage:$perPage,page:$page) {
     itemCount
     pageCount
     hasNextPage
     hasPreviousPage   
     bookmarks{
            _id           
            topicId          
             subjectId           
             test{
                title
                _id
                serverTime
                schedule
                endTest
                questionCount
                duration
                purchaseStatus
                progress{
                    _id      
                    endTime            
                    isCompleted                
                        attemptedQuesCount
                        questions{
                            questionId
                            }
                    }
                    subjectDetail{
                    subjectId
                    subjectName
                    topicId
                    topicName
                }
            }          
             pearl{
                 _id
                 title
                 pearlsCode
                 progress{
                        _id
                        isCompleted
                        isBookMarked
                     }               
                      subjectDetail{
                 subjectId
                 subjectName
                 topicId
                 topicName
                 }
            }          
             questionbank {
                    _id
                     title
                     subject                    
                     rating
                     questionIds
                     purchaseStatus
                     subjectDetail{
                     topicId
                     subjectId
                     subjectName
                     topicName
                      }                    
                      questions{
                        question{
                        questionText
                        questionImage
                        }
                    }                   
                    progress{
                    _id                   
                    duration
                    questions{
                        questionId
                    }                   
                    questionInterval
                     }
                    questions{
                     _id
                     answer
                          }
                     }
                  video {
                         _id
                         videoUrlId
                        topic 
                        subject 
                         title
                          duration
                         isNewVideo
                         language
                        parentLayer{
                          _id
                          title
                        }
                        progress{
                               _id  
                               isCompleted                         
                               duration{
                             duration
                            language
                                }
                              }
                    videoUrls {
                       language
                       videoUrlId
                       duration
                   fragments {
                     topicTitle
                          from
                             to
                    }
                      }
                        rating
                         position
                         purchaseStatus
                        thumbnail
                          author{
                                    name
                                   }
                         subjectDetail{
                                subjectName
                                topicName
                                topicId
                                subjectId
                          }
                    }
                  }       
 }
 }`

export const GET_Other_Resource = gql`
query topicList($layerId: String!, $language: String!, $contentType: String!) {
  layer(_id: $layerId) {
      _id
      title
      parents
      layerType
      description
      icon
      subject
      totalContent
      author {
          name
      }
      progressStatus{
            score
      }
      subLayers {
          position
          _id
          layerType
          icon
          versions
          title
          progressStatus {
              score
          }
          author {
              name
          }
          totalContent
          subContents(language: $language, contentType: $contentType) {
              contentId
              pearl {
                  _id
                  pearlsCode
                  title
                  description
                  status
              }
          }
          subLayers {
              position
              _id
              title
              icon
              layerType
              versions
              totalContent
              author{
                  name
              }
              progressStatus{
                  score
              }
              subContents(language: $language, contentType: $contentType) {
                  contentId
              }
          }
      }
      subContents(language: $language, contentType: $contentType){
      questionBank {
          _id
          title
          icon
          purchaseStatus
          rating
          questionIds
          subjectDetail {
            subjectName
            subjectId
            topicId
            topicName
            }
          progress{
               questions {
              questionId
            }
            isCompleted
          }
      }
      video {
          _id
          title
          subject
          language
          version
          topic
          author{
              name
          }
          thumbnail
          parentLayer{
              title
          }
          rating
          notes
          duration
          purchaseStatus
          videoUrlId
              subjectDetails {
                   _id
                   subjectName
                    topic {
                 topicName
              }
          }
          progress {
              _id
              isBookMarked
              isCompleted
              duration {
                  duration
                  language
              }
          }
             videoUrls {
                    language
                  videoUrlId
                  duration
              fragments {
                   topicTitle
                   from
                   to
                  }
              }
      }
      }
  }
}`

export const GET_Qb_Other_Resource = gql`
query topic($layerId: String!, $language: String!, $contentType: String!) {
  layer(_id: $layerId) {
      _id
      title
      parents
      layerType
      description
      icon
      subject
      totalContent
      author {
          name
      }
      progressStatus{
            score
      }
      subLayers {
          position
          _id
          layerType
          icon
          title
          progressStatus {
              score
          }
          author {
              name
          }
          totalContent
          subContents(language: $language, contentType: $contentType) {
              contentId
              pearl {
                  _id
                  pearlsCode
                  title
                  description
                  status
              }
          }
          subLayers {
              position
              _id
              title
              icon
              layerType
              totalContent
              author{
                  name
              }
              progressStatus{
                  score
              }
              subContents(language: $language, contentType: $contentType) {
                  contentId
              }
          }
      }
      subContents(language: $language, contentType: $contentType){
      questionBank {
          _id
          title
          icon
          purchaseStatus
          rating
          questionIds
          subjectDetail {
          subjectName
          }
          progress{
               questions {
              questionId
            }
            isCompleted
          }
      }
      video {
          _id
          title
          subject
          language
          version
          topic
          author{
              name
          }
          thumbnail
          parentLayer{
              title
          }
          rating
          notes
          duration
          purchaseStatus
          videoUrlId
              subjectDetails {
                   _id
                   subjectName
                    topic {
                 topicName
              }
          }
          progress {
              _id
              isBookMarked
              isCompleted
              duration {
                  duration
                  language
              }
          }
             videoUrls {
                    language
                  videoUrlId
                  duration
              fragments {
                   topicTitle
                   from
                   to
                  }
              }
      }
      }
  }
}`

export const jump_mantra = gql`
query pearlByCode($pearlCode: String!) {
  pearlByCode(pearlCode: $pearlCode) {
    _id
    title
    description
    pearlsCode
    progress{
      isBookMarked
    }
    status
    subjectDetail{
       subjectName
       topicName
       subjectId
       topicId
       }
  }
}`

export const Get_Mantra_Topic = gql`
query topicList($_id:String!, $language: String!, $contentType: String!) {
  layer(_id: $_id) {
      _id
      title
      description
      icon
      totalContent
      author {
          name
      }
      progressStatus{
            score
      }
      subLayers {
          position
          _id
          layerType
          icon
          title
          progressStatus {
              score
          }
          author {
              name
          }
          totalContent
          subContents(language: $language, contentType: $contentType) {
              contentId
              pearl {
                  _id
                  pearlsCode
                  title
                  description
                  status
                  progress{
                    isBookMarked
                  }                   
                  subjectDetail
                  {
                    subjectId
                    subjectName 
                    topicId
                    topicName
                  }
                }
          }
          subLayers {
              position
              _id
              title
              icon
          totalContent
              author{
                  name
              }
              progressStatus{
                  score
              }
              subContents(language: $language, contentType: $contentType) {
                  contentId
              }
          }
      }
      subContents(language: $language, contentType: $contentType){
      video {
          _id
          title
          author{
          name
          }
          thumbnail
          rating
          duration
          videoUrlId
          progress {
              isBookMarked
              isCompleted
              duration {
                  duration
              }
          }
      }
      }
  }
}
`
export const View_Ranker = gql`
query getRank($qbId:String!,$page:Int!,$perPage:Int!){
	getRanks(qbId:$qbId,page:$page,perPage:$perPage){
	  results {
		totalMarks
		marks
		rank
		unattemptedQids
		questions {
		  userAnswer
		  isCorrect
		}
		user {
		  name
		  avatar
		}
	  }
	}
  }
`
export const GET_Sidebar_Instrucation_QB = gql`
query qbInformation($_id:String!){
  qb(_id:$_id){
    _id
    qbCode
    title
    description
    instruction
    status
    course
    deleteStatus
    subject
    parentLayerId
    parentLayer {
      title
      _id
    }
    subjectDetail {
      subjectId
      topicId
    }
    authorDetails {
      name
    }
    icon
    purchaseStatus
    rating
    progress{
        _id
      isCompleted
      startTime
      questionInterval
      bookmarkedQids
      isBookMarked
      questions {
        questionId
        userAnswer
    }
    }
    questions{
      _id
      questionCode
      topic
      tags
      reference
      status
      answer
      totalAttemptCount
      answer
      subjectDetail {
        subjectName
        subjectId
      }
        elements {
            type
            data
        }
      question{
        questionText
        questionImage
            }
        solution {
        solutionImage
        solutionText
    }
      options{
        _id
        optionText
        optionAttempt
        optionImage
            }
        }
    }
}`

export const GET_Sidebar_Qb_Other_Resource = gql`
query topic($layerId: String!, $language: String!, $contentType: String!) {
  layer(_id: $layerId) {
      _id
      title
      parents
      layerType
      description
      icon
      subject
      totalContent
      author {
          name
      }
      progressStatus{
            score
      }
      subLayers {
          position
          _id
          layerType
          icon
          title
          progressStatus {
              score
          }
          author {
              name
          }
          totalContent
          subContents(language: $language, contentType: $contentType) {
              contentId
              pearl {
                  _id
                  pearlsCode
                  title
                  description
                  status
              }
          }
          subLayers {
              position
              _id
              title
              icon
              layerType
              totalContent
              author{
                  name
              }
              progressStatus{
                  score
              }
              subContents(language: $language, contentType: $contentType) {
                  contentId
              }
          }
      }
      subContents(language: $language, contentType: $contentType){
      questionBank {
          _id
          title
          icon
          purchaseStatus
          rating
          questionIds
          subjectDetail {
          subjectName
          }
          progress{
               questions {
              questionId
            }
            isCompleted
            startTime
            questionInterval
          }
      }
      video {
          _id
          title
          subject
          language
          version
          topic
          author{
              name
          }
          thumbnail
          parentLayer{
              title
          }
          rating
          notes
          duration
          purchaseStatus
          videoUrlId
              subjectDetails {
                   _id
                   subjectName
                    topic {
                 topicName
              }
          }
          progress {
              _id
              isBookMarked
              isCompleted
              duration {
                  duration
                  language
              }
          }
             videoUrls {
                    language
                  videoUrlId
                  duration
              fragments {
                   topicTitle
                   from
                   to
                  }
              }
      }
      }
  }
}`

export const GET_Subscription_Order = gql`
query myorders($perPage: Float!, $page: Float!, $purchaseType: PurchaseType) {
  myOrders(perPage: $perPage, page: $page, purchaseType: $purchaseType) {
    orders {
		_id
      purchaseType
      buyDate
      expiryDate
      couponCode
      expire
      priceAfterCoupon
      hasExpired
      couponDiscount
      boughtWithVibe
      boughtWithNotes
      invoiceNumber
      packageType
	  coinDiscount
	  coinUse
	  finalAmount
	  boughtWithNotes
	  boughtWithVibe
	  isAssignedPackageByAdmin
	  linkedAddOnPurchase
      packageDetails {
        title
        description
        newDescription
      }
      transactionStatus
      planPurchased {
        months
        withNotes
        withPenDrive
        mrp
        discountPrice
        notes {
          notesPurchasedWithSubscription
          title
          notesPackageId
          notesPaidAmount
          notesPrice
          notesDiscount
          notesCouponDiscount
          afterBuyNotesPrice
          afterBuyNotesDiscount
        }
        vibe {
          penDrivePurchasedWithSubscription
          title
          penDrivePackageId
          penDrivePrice
          penDriveCouponDiscount
          penDrivePaidAmount
          penDriveDiscount
          afterBuyPendrivePrice
          afterBuyPendriveDiscount
        }
      }
      billingAddress {
        fullAddress
		colonyArea
		flatNumber
		landmark
		city
		state
		country
		pincode
      }
      shippingAddress {
        fullAddress
		colonyArea
		flatNumber
		landmark
		city
		state
		country
		pincode
      }
	  userForAdmin{
		name,
		avatar,
		email,
		mobileNo
	  }
    }
    hasNextPage
    hasPreviousPage
    pageCount
  }
}`

export const Package_detail_Api = gql`
query listPackagesForApp(
  $categoryId: String
  $videoSubjectId: String
  $qbSubjectId: String
  $testId: String
  $packageType: PackageType
  $packageId: String
) {
  listPackagesForApp(
    categoryId: $categoryId
    videoSubjectId: $videoSubjectId
    qbSubjectId: $qbSubjectId
    testId: $testId
    packageId: $packageId
    packageType: $packageType
  ) {
   _id
    title
    subtitle
    position
    category
    isAvailableExtension
    isAddressMandatory
    colorCode
    description
    packageType
    newDescription
    validity {
      _id
      discountPrice
      mrp
      months
      validityTitle
      withPenDrive
      withNotes
      isCouponApply
      notes {
        title
        notesPackageId
        description
        notesPrice
        notesDiscount
        afterBuyNotesPrice
        afterBuyNotesDiscount
        isCouponApply
      }
      penDrive {
        title
        penDrivePackageId
        description
        penDrivePrice
        penDriveDiscount
        afterBuyPendrivePrice
        afterBuyPendriveDiscount
        isCouponApply
      }
    }
    packageExtension {
      activePackage
      allActivePackage
      allExpiredPackage
      beforeExpiryPackage
      description
      expiredPackage
      expiryFromPackage
      expiryFromToCurrent
      expiryToPackage
      validity {
        _id
        number
        vtype
        mrp
      }
    }
    packagePurchased {
      expire
      hasExpired
      transactionStatus
      validityId
      boughtWithVibe
      boughtWithNotes
      isAssignedPackageByAdmin
      planPurchased {
        _id
      }
    }
    recommendedSubscriptionForAddOn {
      packageId
      boughtWithVibe
      boughtWithNotes
      planPurchased {
        _id
       months
       validityTitle
       isCouponApply
        notes {
          notesPackageId
          afterBuyNotesPrice
          afterBuyNotesDiscount
          isCouponApply
        }
         vibe {
          penDrivePackageId
          afterBuyPendrivePrice
          afterBuyPendriveDiscount
          isCouponApply
        }
      }
    }
  }
}`

export const GetQuestionBookmarks = gql`
query profileBookMarks($page:Int!,$perPage:Int!,$subjectIds: [String!],$topicIds:[String!],$courseName:String) {
	questionBookMarks (page: $page,perPage:$perPage,subjectIds:$subjectIds,topicIds:$topicIds,courseName:$courseName) {
		pageCount
		itemCount
	questionBookMarks{
		resultType
    _id
		courseName
		userId
		userAnswer
		question{
			_id
      answer
      question{
        questionText
        questionImage
      }
      reference
      tags
      hashtags
      questionCode
      options{
        _id
        optionText
        optionAttempt
      }
      elements{
        type
        data
      }
      referenceExam
      solution{
        solutionText
        solutionImage
      }
      subject
      subjectDetail{
        subjectName
      }
		}
		testQuestion{
		_id
    answer
    question{
      questionText
      questionImage
    }
    referenceExam
    elements{
      type
      data
    }
    questionCode
    reference
    tags
    hashtags
    options{
      _id
      optionText
      optionAttempt
    }
    solution{
      solutionText
      solutionImage
    }
    subject
    subjectDetail{
      subjectName
    }
		}
	}
	} 
}`

export const questionSubjectTopic = gql`
query cqbSubject($course: String!,$subjectType: String!)
	{
		cqbSubject(course: $course,subjectType: $subjectType ){
		_id
        subjectCode
        subjectName
        position
        subjectType
        qbTopics{
          _id
          title
        }
		}
	}
`
